import { Typography } from '@mui/material';
import styled from 'styled-components';

const StyledTypography = styled(Typography)`
  padding-bottom: ${props => props.theme.spacing(2)};
`;

interface Props {
  children: React.ReactNode;
}

export const AppFormDescription = ({ children }: Props) => {
  return <StyledTypography variant="body2">{children}</StyledTypography>;
};
